export default __webpack_public_path__ + "static/media/buy-a-house.5642fcae.svg";